import {useSelector} from "react-redux";

export default function useSalesforceOrgConfigUpdateInfo() {
    const salesforceOrgConfig = useSelector(state => state.salesforceOrgConfig);
    const lastUpdatedHandleId = salesforceOrgConfig.lastUpdatedHandleId;
    const error = salesforceOrgConfig.error;
    return {lastUpdatedHandleId, error};
}
